package tables.ad

import adToJsonString
import emotion.react.css
import entities.Ad
import kotlinx.browser.window
import org.w3c.fetch.RequestInit
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.p
import react.useState
import token
import urlAddress
import web.cssom.*
import web.html.InputType
import web.http.Headers

external interface UpdateAdProps : Props {
    var ad: Ad?
    var onClose: () -> Unit
    var onUpdate: () -> Unit

}

val UpdateAdModal = FC<UpdateAdProps> { props ->
    if (props.ad != null) {
        var adName by useState(props.ad?.name ?: "")
        var status by useState("")
        var message by useState(props.ad?.message ?: "")

        div {
            css {
                borderRadius = 10.px
                padding = 20.px
                position = Position.fixed
                top = 50.pct
                left = 50.pct
                transform = translate((-50).pct, (-50).pct)
                backgroundColor = rgb(142, 178, 170)
                display = Display.flex
                alignItems = AlignItems.center
                justifyContent = JustifyContent.center
            }

            div {
                p {
                    +"Наименование:"
                }
                input {
                    css {
                        fontSize = 14.px
                        width = 100.pct
                    }
                    value = adName
                    type = InputType.text
                    onChange = { event ->
                        adName = event.target.value
                    }
                }
                p {
                    +"Сообщение:"
                }
                input {
                    css {
                        fontSize = 14.px
                        width = 100.pct
                    }
                    value = message
                    type = InputType.text
                    onChange = { event ->
                        message = event.target.value
                    }
                }
                div {
                    css {
                        paddingTop = 20.px
                        display = Display.flex
                        justifyContent = JustifyContent.spaceAround
                    }
                    button {
                        disabled = (adName.length < 3) || (message.length < 10)
                        +"Сохранить"
                        val ad = Ad(props.ad!!.id, adName, message)
                        onClick = {
                            window.fetch(
                                urlAddress + "api/ads", RequestInit(
                                    method = "PUT",
                                    headers = Headers().apply {
                                        append("Authorization", "Bearer $token")
                                        append("Content-Type", "application/json")
                                    },
                                    body = adToJsonString(ad)
                                )
                            )
                                .then { response ->
                                    if (response.ok) {
                                        props.onClose()
                                        props.onUpdate()
                                    } else {
                                        status = "Ошибка"
                                    }
                                }
                        }
                    }
                    button {
                        +"Отмена"
                        onClick = {
                            props.onClose()
                        }
                    }
                }
                p {
                    +status
                }
            }
        }
    }
}
